// import { Chip, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import {
  Alert,
  Button,
  Grid,
  InputLabel,
  InputAdornment,
  FormControl,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery,
  Autocomplete,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

export default function PostsFilters({
  page,
  totalPages,
  setSearchText,
  setTopic,
  setCategory,
}) {
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({
    name: "All Categories",
  });
  const [selectedTopic, setSelectedTopic] = useState({ name: "All Topics" });
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const category = [{ name: "All Categories" }, ...WP_API_Settings.category];
  const topic = [{ name: "All Topics" }, ...WP_API_Settings.topic];

  //update parent component with topic abd categories
  const handleFilter = ({ selectedCategory, selectedTopic }) => {
    setCategory(selectedCategory);
    setTopic(selectedTopic);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  console.log(category, topic);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={12}>
        <Box
          sx={{
            m: "2rem 0",
            display: "flex",
            flexDirection: mdDown ? "column" : "row",
            alignItems: "center",
            justifyContent: "left",
            gap: "0.5rem",
          }}
        >
          <Box
            sx={{
              minWidth: 160,
            }}
          >
            <Autocomplete
              disableClearable
              options={category}
              value={selectedCategory}
              onChange={(event, newValue) => {
                setSelectedCategory(newValue);
                //setCategory(newValue);
              }}
              getOptionLabel={(option) => option.name}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  borderRadius: 10,
                },
              }}
              renderInput={(params) => (
                <TextField {...params} label="Category" />
              )}
            />
          </Box>

          {/* <Box> 

            <FormControl
              variant="outlined"
              sx={{
                minWidth: 200,
              }}
            >
              <InputLabel
                aria-label="category-label"
                id="category-label"
                sx={{ color: (theme) => theme.palette.primary.main }}
              >
                <Typography variant="p">Category</Typography>
              </InputLabel>
              <Select
                labelId="category-label"
                id="category-select"
                value={selectedCategory}
                Category
                onChange={(e) => setSelectedCategory(e.target.value)}
                label="Category"
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  border: "1px solid #fff",
                  height: "45px",
                  width: "100%",
                  borderRadius: 10,

                }}
              >
                <MenuItem value="all">
                  {" "}
                  <Typography variant="p">All categories</Typography>
                </MenuItem>

                {category
                  ? category.map((thisCategory) => (
                      <MenuItem
                        key={thisCategory.term_id}
                        value={thisCategory}
                      >
                        <Typography variant="p">{thisCategory.name}</Typography>
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Box> */}
          <Box
            sx={{
              minWidth: 160,
            }}
          >
            <Autocomplete
              disableClearable
              options={topic}
              value={selectedTopic}
              onChange={(event, newValue) => {
                setSelectedTopic(newValue);
                //setTopic(newValue);
              }}
              getOptionLabel={(option) => option.name}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  borderRadius: 10,
                },
              }}
              renderInput={(params) => <TextField {...params} label="Topic" />}
            />
          </Box>

          {/* <FormControl
              variant="outlined"
              FilledInput={false}
              sx={{ minWidth: 200 }}
            >
              <InputLabel
                aria-label="topic-label"
                id="topic-label"
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  boderColor: (theme) => theme.palette.primary.main,
                  textAlign: "center",
                }}
              >
                <Typography variant="p">Topic</Typography>
              </InputLabel>
              <Select
                labelId="topic-label"
                id="topic-select"
                value={selectedTopic}
                onChange={(e) => setSelectedTopic(e.target.value)}
                label="Topic"
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  border: "1px solid #fff",
                  height: "45px",
                  width: "100%",
                  borderRadius: 10,
                }}
              >
                <MenuItem value="all">
                  <Typography variant="p">All topics</Typography>
                </MenuItem>
                {topic
                  ? topic.map((thisTopic) => (
                      <MenuItem key={thisTopic.term_id} value={thisTopic}>
                        <Typography variant="p">{thisTopic.name}</Typography>
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl> */}

          <Button
            size="large"
            onClick={() => {
              console.log(selectedCategory, selectedTopic);
              handleFilter({
                selectedCategory,
                selectedTopic,
              });
            }}
            sx={{
              borderRadius: "0.25rem",
              alignItems: "center",
              cursor: "pointer",
              border: "1px solid #fff",
              padding: "2rem",
              width: "25%",
              borderRadius: 10,
              backgroundColor: (theme) => theme.palette.primary.main,
              color: "#fff",
              m: "2rem 0",
              padding: "0.9rem",
              "&:hover": {
                backgroundColor: (theme) => theme.palette.secondary.main,
              },
            }}
          >
            Filter
          </Button>
          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity="warning"
              sx={{
                backgroundColor: "#ea0606",
                color: "red",
                marginTop: mdDown ? "530px" : "275px",
                translate: mdDown ? 0 : "250px",
              }}
            >
              No case insights found with the selected filters.
            </Alert>
          </Snackbar>
          <Grid item xs={12} md={12}>
            {totalPages > 0 && (
              <Typography
                sx={{
                  mt: "1rem",
                  textAlign: "right",
                }}
              >
                {"Page " + page + " of " + totalPages}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              placeholder="Search Insights"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setSearchText(e.target.value);
              }}
              InputProps={{
                id: "search-field",
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{
                        color: (theme) => theme.palette.grey.main,
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
